import bugsnag from './client';

const ErrorBoundary = bugsnag.getPlugin('react');

export default ErrorBoundary;
